export default __webpack_public_path__ + "files/d5daf742611b86ea2649597d5076604f.woff2";